export class WbPdfBook {
  constructor() {}

  init() {
    return new Promise(resolve => {
      jQuery('.wb-pdf-book__book')?.each(function() {
        const pdfFile = jQuery(this).attr('data-src');
        if (!pdfFile) return;
        var bookOptions = {
          height: $(this).parent().innerWidth(),
          maxHeight: 900,
          width: $(this).parent().innerWidth(),
          centeredWhenClosed: true,
          hardcovers: true,
          pageNumbers: false,
          toolbar:
            'lastLeft, left, right, lastRight, toc, zoomin, zoomout, slideshow, flipsound, fullscreen, thumbnails, download',
          thumbnailsPosition: 'left',
          responsiveHandleWidth: 50,
          container: $(this).parent(),
          containerPadding: '20px',
          pdf: pdfFile,
        };
        jQuery(this).wowBook(bookOptions);
      });

      resolve();
    });
  }
}
